import updatePass from './changePass';

const watchUpdatePass = [updatePass];

export default watchUpdatePass;
